import { useEffect } from 'react';
import {
  useLocation
} from "react-router-dom";
import { CompanyStoreMetadata } from './CompanyStoreMetadata'
import { Helmet } from 'react-helmet-async';

export default function Metadata() {

	const companyStore = 'company-store'
	let currentLocation = useLocation();

	useEffect(() => { }, [currentLocation]);
	
	const defaultMetaDescription = 'The most reliable B2B trading platform for North American manufacturing industry and commerce. Expand your supplier network. Find manufacturers for customized products. Reduce costs & lead time, and simplify logistics buying from verified businesses in Mexico, USA, & Canada.';
	const defaultMetaKeywords = 'Mexico Suppliers, Manufacture in Mexico, Export to USA, B2B, North American Suppliers, Nearshoring, Local Suppliers, Wholesale Trade, Sourcing in Mexico, Sourcing in America, Mexican manufacturing, Mexican factories';

	if (currentLocation.pathname.includes(companyStore)) {
		return (<CompanyStoreMetadata />);
	}
	
	return (
		<Helmet>
			<title>Bainub</title>
			<meta name="description" content={defaultMetaDescription} />
			<meta name="keywords" content={defaultMetaKeywords} />
		</Helmet>
	);
}